import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import ClientPortalView from '@/views/ClientPortalView.vue'
import QuestionnaireView from '@/views/QuestionnaireView.vue'
import PdfView from '../views/PdfView.vue'
import QuestionnairePreviewView from '@/views/QuestionnairePreviewView.vue'
import QuestionnaireExternalView from '@/views/QuestionnaireExternalView.vue'
import QuestionnaireExternalRedirectView from '@/views/QuestionnaireExternalRedirectView.vue'
import ExternalQuestionnaireCompletedView from '@/views/ExternalQuestionnaireCompletedView.vue'
import PdfExternalRedirectView from '@/views/PdfExternalRedirectView.vue'
import VoiceBotFeedback from '@/views/VoiceBotFeedbackView.vue'

import DashboardBase from '@/views/admin/DashboardBase.vue'
import DashboardView from '@/views/admin/DashboardView.vue'
import AdminCallList from '@/views/admin/voice/CallListView.vue'
import AdminCallDetail from '@/views/admin/voice/CallDetailView.vue'
import FormCreateView from '@/views/admin/documents/DocumentCreateView.vue'
import AdminPDFDocumentsView from '@/views/admin/documents/DocumentListView.vue'
import { ROUTES, ROUTE_BASES } from '@/router/routes'
import { type IStaticMethods } from 'preline/preline'
import DocumentDetailView from '@/views/admin/documents/DocumentDetailView.vue'
import CustomersListView from '@/views/admin/customers/CustomersListView.vue'
import CustomersDetailView from '@/views/admin/customers/CustomersDetailView.vue'
import CustomersMapView from '@/views/admin/customers/CustomersMapView.vue'
import InvoiceListView from '@/views/admin/payments/InvoiceListView.vue'
import InvoiceExportView from '@/views/admin/payments/InvoiceExportView.vue'
import PhoneNumberCreateView from '@/views/admin/voice/PhoneNumberCreateView.vue'
import PhoneNumberDetailView from '@/views/admin/voice/PhoneNumberDetailView.vue'
import PhoneNumberListView from '@/views/admin/voice/PhoneNumberListView.vue'
import IntegrationsExportView from '@/views/integrations/ExportView.vue'
import QuestionnaireListView from '@/views/admin/questionnaires/QuestionnaireListView.vue'
import QuestionnaireDetailView from '@/views/admin/questionnaires/QuestionnaireDetailView.vue'
import UsersListView from '@/views/admin/users/UsersListView.vue'
import UsersDetailView from '@/views/admin/users/UserDetailView.vue'
import TEMPORARYCaseLawSpecificDataView from '@/views/cases/TEMPORARYCaseLawSpecificDataView.vue'
import JupusAddressSettingsView from '@/views/app/settings/email/JupusAddressSettingsView.vue'
import TemplateSettingsView from '@/views/app/settings/email/TemplateSettingsView.vue'
import NotificationsSettingsView from '@/views/app/settings/email/NotificationsSettingsView.vue'
import PlaceholdersSettingsView from '@/views/app/settings/email/PlaceholdersSettingsView.vue'
import SettingsBase from '@/components/app/settings/SettingsBase.vue'
import AppointmentsSetupSettingsView from '@/views/app/settings/appointments/AppointmentsSetupSettingsView.vue'
import AppointmentCalendarListSettingsView from '@/views/app/settings/appointments/AppointmentCalendarListSettingsView.vue'
import AppointmentsCalendarDetailSettingsView from '@/views/app/settings/appointments/AppointmentsCalendarDetailSettingsView.vue'
import AppointmentsServiceListSettingsView from '@/views/app/settings/appointments/AppointmentsServiceListSettingsView.vue'
import AppointmentsServiceDetailSettingsView from '@/views/app/settings/appointments/AppointmentsServiceDetailSettingsView.vue'
import AppointmentsBaseSettingsView from '@/views/app/settings/appointments/AppointmentsBaseSettingsView.vue'
import AppointmentsLinksSettingsView from '@/views/app/settings/appointments/AppointmentsLinksSettingsView.vue'
import AppointmentsEmbedSettingsView from '@/views/app/settings/appointments/AppointmentsEmbedSettingsView.vue'
import SignatureSettingsView from '@/views/app/settings/email/SignatureSettingsView.vue'
import DesignSettingsView from '@/views/app/settings/email/DesignSettingsView.vue'
import TemplateDetailSettingsView from '@/views/app/settings/email/TemplateDetailSettingsView.vue'
import CaseDetailBaseView from '@/views/app/cases/case-detail/CaseDetailBaseView.vue'
import CaseDetailOverviewView from '@/views/app/cases/case-detail/CaseDetailOverviewView.vue'
import CaseDetailCommunicationView from '@/views/app/cases/case-detail/CaseDetailCommunicationView.vue'
import CaseDetailDocumentsView from '@/views/app/cases/case-detail/CaseDetailDocumentsView.vue'
import CaseDetailAppointmentsView from '@/views/app/cases/case-detail/CaseDetailAppointmentsView.vue'
import CaseDetailLawSpecificDataView from '@/views/app/cases/case-detail/CaseDetailLawSpecificDataView.vue'
import CaseDetailTimelineView from '@/views/app/cases/case-detail/CaseDetailTimelineView.vue'
import InboundEmailListView from '@/views/admin/emails/InboundEmailListView.vue'
import InboundEmailDetailView from '@/views/admin/emails/InboundEmailDetailView.vue'
import WordDocumentGenerationTemplateSettingsView from '@/views/app/settings/ai/WordDocumentGenerationTemplateSettingsView.vue'
import WordDocumentGenerationTemplateDetailSettingsView from '@/views/app/settings/ai/WordDocumentGenerationTemplateDetailSettingsView.vue'
import CallDetailView from '@/views/app/calls/CallDetailView.vue'
import CaseCreateView from '@/views/app/cases/CaseCreateView.vue'
import CallListView from '@/views/app/calls/CallListView.vue'
import TEMPORARYCaseAiChatView from '@/views/cases/TEMPORARYCaseAiChatView.vue'
import CaseDetailEntitiesView from '@/views/app/cases/case-detail/CaseDetailEntitiesView.vue'
import TEMPORARYCaseEntitiesView from '@/views/cases/TEMPORARYCaseEntitiesView.vue'
import PromptTemplateSettingsView from '@/views/app/settings/ai/PromptTemplateSettingsView.vue'
import AiBaseSettingsView from '@/views/app/settings/ai/AiBaseSettingsView.vue'
import PromptTemplateDetailSettingsView from '@/views/app/settings/ai/PromptTemplateDetailSettingsView.vue'
import FeedbackListView from '@/views/admin/feedback/FeedbackListView.vue'
import FeedbackDetailView from '@/views/admin/feedback/FeedbackDetailView.vue'
import ChatListView from '@/views/admin/chats/ChatListView.vue'
import ChatDetailView from '@/views/admin/chats/ChatDetailView.vue'
import TEMPORARYCaseWordDocumentGeneratorView from '@/views/cases/TEMPORARYCaseWordDocumentGeneratorView.vue'
import WordTemplateReviewListView from '@/views/admin/wordTemplates/WordTemplateReviewListView.vue'
import WordTemplateReviewDetailView from '@/views/admin/wordTemplates/WordTemplateReviewDetailView.vue'
import RaMicroSettingsView from '@/views/app/settings/law-office-software/RaMicroSettingsView.vue'
import AdvowareSettingsView from '@/views/app/settings/law-office-software/AdvowareSettingsView.vue'
import AdvoluxSettingsView from '@/views/app/settings/law-office-software/AdvoluxSettingsView.vue'
import ActaportSettingsView from '@/views/app/settings/law-office-software/ActaportSettingsView.vue'
import AnnotextSettingsView from '@/views/app/settings/law-office-software/AnnotextSettingsView.vue'
import JurnodesSettingsView from '@/views/app/settings/law-office-software/JurnodesSettingsView.vue'
import KleosSettingsView from '@/views/app/settings/law-office-software/KleosSettingsView.vue'
import LawfirmSettingsView from '@/views/app/settings/law-office-software/LawfirmSettingsView.vue'

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods
  }
}

// Define the /admin routes
const adminRoutes: RouteRecordRaw[] = [
  {
    path: ROUTES.ADMIN.ROOT,
    name: 'Dashboard',
    component: DashboardBase,
    meta: {
      title: 'Admin Dashboard'
    },
    children: [
      {
        path: ROUTES.ADMIN.DASHBOARD,
        component: DashboardView,
        meta: { title: 'Admin Dashboard Overview' }
      },
      {
        path: ROUTES.ADMIN.VOICE.CALL_LIST,
        component: AdminCallList,
        meta: { title: 'Admin Call History' }
      },
      {
        path: ROUTES.ADMIN.VOICE.CALL_DETAIL,
        component: AdminCallDetail,
        meta: { title: 'Admin Call Details' }
      },
      {
        path: ROUTES.ADMIN.VOICE.PHONE_NUMBER_LIST,
        component: PhoneNumberListView,
        meta: { title: 'Admin Phone Numbers' }
      },
      {
        path: ROUTES.ADMIN.VOICE.PHONE_NUMBER_CREATE,
        component: PhoneNumberCreateView,
        meta: { title: 'Admin Add Phone Number' }
      },
      {
        path: ROUTES.ADMIN.VOICE.PHONE_NUMBER_DETAIL,
        component: PhoneNumberDetailView,
        meta: { title: 'Admin Phone Number Details' }
      },
      {
        path: ROUTES.ADMIN.EMAIL.INBOUND_EMAIL_LIST,
        component: InboundEmailListView,
        meta: { title: 'Admin Inbound Emails' }
      },
      {
        path: ROUTES.ADMIN.EMAIL.INBOUND_EMAIL_DETAIL,
        component: InboundEmailDetailView,
        meta: { title: 'Admin Email Details' }
      },
      {
        path: ROUTES.ADMIN.DOCUMENTS.DOCUMENTS_LIST,
        component: AdminPDFDocumentsView,
        meta: { title: 'Admin Documents' }
      },
      {
        path: ROUTES.ADMIN.DOCUMENTS.DOCUMENT_CREATE,
        component: FormCreateView,
        meta: { title: 'Admin Create Document' }
      },
      {
        path: ROUTES.ADMIN.DOCUMENTS.DOCUMENT_DETAIL,
        component: DocumentDetailView,
        meta: { title: 'Admin Document Details' }
      },
      {
        path: ROUTES.ADMIN.CUSTOMERS.CUSTOMER_LIST,
        component: CustomersListView,
        meta: { title: 'Admin Customers' }
      },
      {
        path: ROUTES.ADMIN.CUSTOMERS.CUSTOMER_DETAIL,
        component: CustomersDetailView,
        meta: { title: 'Admin Customer Details' }
      },
      {
        path: ROUTES.ADMIN.CUSTOMERS.CUSTOMER_MAP,
        component: CustomersMapView,
        meta: { title: 'Admin Customer Map' }
      },
      {
        path: ROUTES.ADMIN.PAYMENTS.INVOICES_LIST,
        component: InvoiceListView,
        meta: { title: 'Admin Invoices' }
      },
      {
        path: ROUTES.ADMIN.PAYMENTS.INVOICES_EXPORT,
        component: InvoiceExportView,
        meta: { title: 'Admin Export Invoices' }
      },
      {
        path: ROUTES.ADMIN.QUESTIONNAIRES.QUESTIONNAIRE_LIST,
        component: QuestionnaireListView,
        meta: { title: 'Admin Questionnaires' }
      },
      {
        path: ROUTES.ADMIN.QUESTIONNAIRES.QUESTIONNAIRE_DETAIL,
        component: QuestionnaireDetailView,
        meta: { title: 'Admin Questionnaire Details' }
      },
      {
        path: ROUTES.ADMIN.USERS.USER_LIST,
        component: UsersListView,
        meta: { title: 'Admin Users' }
      },
      {
        path: ROUTES.ADMIN.USERS.USER_DETAIL,
        component: UsersDetailView,
        meta: { title: 'Admin User Details' }
      },
      {
        path: ROUTES.ADMIN.FEEDBACK.FEEDBACK_LIST,
        component: FeedbackListView,
        meta: { title: 'Admin Feedback' }
      },
      {
        path: ROUTES.ADMIN.FEEDBACK.FEEDBACK_DETAIL,
        component: FeedbackDetailView,
        meta: { title: 'Admin Feedback Details' }
      },
      {
        path: ROUTES.ADMIN.CHATS.CHAT_LIST,
        component: ChatListView,
        meta: { title: 'Admin Chats' }
      },
      {
        path: ROUTES.ADMIN.CHATS.CHAT_DETAIL,
        component: ChatDetailView,
        meta: { title: 'Admin Chat Details' }
      },
      {
        path: ROUTES.ADMIN.WORD_TEMPLATES.REVIEW,
        component: WordTemplateReviewListView,
        meta: { title: 'Admin Word Templates' }
      },
      {
        path: ROUTES.ADMIN.WORD_TEMPLATES.REVIEW_DETAIL,
        component: WordTemplateReviewDetailView,
        meta: { title: 'Admin Word Template Details' }
      }
    ]
  }
]

const appRoutes: RouteRecordRaw[] = [
  {
    path: ROUTES.APP.CASES.CASE_CREATE,
    name: 'Create Case',
    component: CaseCreateView,
    meta: { title: 'Fall erstellen' }
  },
  {
    path: ROUTES.APP.EXPORT,
    name: 'Integrations Export',
    component: IntegrationsExportView,
    meta: { title: 'Export' }
  },
  // INTERMIDIATE ROUTES, JUST SO WE CAN GET CASE SPECIFIC DATA OUT
  {
    path: ROUTES.APP.CASES.CASE_DETAIL.LAW_SPECIFIC_DATA,
    name: 'Case Law Specific Data',
    component: TEMPORARYCaseLawSpecificDataView,
    meta: { title: 'Rechtsspezifische Daten' }
  },
  {
    path: ROUTES.APP.CASES.CASE_DETAIL.ENTITIES,
    name: 'Entities',
    component: TEMPORARYCaseEntitiesView,
    meta: { title: 'Beteiligte' }
  },
  {
    path: ROUTES.APP.CASES.CASE_DETAIL.DOCUMENT_GENERATION,
    name: 'Case Document Generation',
    component: TEMPORARYCaseWordDocumentGeneratorView,
    meta: { title: 'Dokumentenerstellung' }
  },
  {
    path: ROUTES.APP.CASES.CASE_DETAIL.AI_CHAT,
    name: 'Case AI Chat',
    component: TEMPORARYCaseAiChatView,
    meta: { title: 'KI Chat' }
  },
  // END OF INTERMIDIATE ROUTES
  {
    path: ROUTES.APP.CASES.CASE_DETAIL.ROOT,
    name: 'Case Detail',
    component: CaseDetailBaseView,
    meta: { title: 'Falldetails' },
    children: [
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.OVERVIEW,
        component: CaseDetailOverviewView,
        meta: { title: 'Fallübersicht' }
      },
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.COMMUNICATION,
        component: CaseDetailCommunicationView,
        meta: { title: 'Kommunikation' }
      },
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.ENTITIES,
        component: CaseDetailEntitiesView,
        meta: { title: 'Beteiligte' }
      },
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.DOCUMENTS,
        component: CaseDetailDocumentsView,
        meta: { title: 'Dokumente' }
      },
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.APPOINTMENTS,
        component: CaseDetailAppointmentsView,
        meta: { title: 'Termine' }
      },
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.LAW_SPECIFIC_DATA,
        component: CaseDetailLawSpecificDataView,
        meta: { title: 'Rechtsspezifische Daten' }
      },
      {
        path: ROUTES.APP.CASES.CASE_DETAIL.TIMELINE,
        component: CaseDetailTimelineView,
        meta: { title: 'Zeitleiste' }
      }
    ]
  },
  {
    path: ROUTES.APP.SETTINGS.ROOT,
    name: 'Settings',
    component: SettingsBase,
    meta: { title: 'Einstellungen' },
    children: [
      // Email settings
      {
        path: ROUTES.APP.SETTINGS.EMAILS.JUPUS_EMAIL,
        component: JupusAddressSettingsView,
        meta: { title: 'Einstellungen > JUPUS E-Mail Adresse' }
      },
      {
        path: ROUTES.APP.SETTINGS.EMAILS.TEMPLATES,
        component: TemplateSettingsView,
        meta: { title: 'Einstellungen > E-Mail-Vorlagen' }
      },
      {
        path: ROUTES.APP.SETTINGS.EMAILS.TEMPLATE_DETAIL,
        component: TemplateDetailSettingsView,
        meta: { title: 'Einstellungen > E-Mail-Vorlagendetails' }
      },
      {
        path: ROUTES.APP.SETTINGS.EMAILS.DESIGN,
        component: DesignSettingsView,
        meta: { title: 'Einstellungen > E-Mail-Design' }
      },
      {
        path: ROUTES.APP.SETTINGS.EMAILS.SIGNATURES,
        component: SignatureSettingsView,
        meta: { title: 'Einstellungen > E-Mail-Signaturen' }
      },
      {
        path: ROUTES.APP.SETTINGS.EMAILS.NOTIFICATIONS,
        component: NotificationsSettingsView,
        meta: { title: 'Einstellungen > Benachrichtigungen' }
      },
      {
        path: ROUTES.APP.SETTINGS.EMAILS.PLACEHOLDERS,
        component: PlaceholdersSettingsView,
        meta: { title: 'Einstellungen > Platzhalter' }
      },
      // Appointments settings
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.SETUP,
        component: AppointmentsSetupSettingsView,
        meta: { title: 'Einstellungen > Termineinrichtung' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.CALENDAR_LIST,
        component: AppointmentCalendarListSettingsView,
        meta: { title: 'Einstellungen > Kalenderübersicht' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.CALENDAR_DETAIL,
        component: AppointmentsCalendarDetailSettingsView,
        meta: { title: 'Einstellungen > Kalenderdetails' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.SERVICE_LIST,
        component: AppointmentsServiceListSettingsView,
        meta: { title: 'Einstellungen > Dienstleistungen' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.SERVICE_DETAIL,
        component: AppointmentsServiceDetailSettingsView,
        meta: { title: 'Einstellungen > Dienstleistungsdetails' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.BASE_SETTINGS,
        component: AppointmentsBaseSettingsView,
        meta: { title: 'Einstellungen > Grundeinstellungen' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.LINKS,
        component: AppointmentsLinksSettingsView,
        meta: { title: 'Einstellungen > Terminbuchungslinks' }
      },
      {
        path: ROUTES.APP.SETTINGS.APPOINTMENTS.EMBED,
        component: AppointmentsEmbedSettingsView,
        meta: { title: 'Einstellungen > Terminbuchung einbetten' }
      },
      {
        path: ROUTES.APP.SETTINGS.AI.DOCUMENT_GENERATION_TEMPLATES,
        component: WordDocumentGenerationTemplateSettingsView,
        meta: { title: 'Einstellungen > Dokumentenvorlagen' }
      },
      {
        path: ROUTES.APP.SETTINGS.AI.DOCUMENT_GENERATION_TEMPLATE_DETAIL,
        component: WordDocumentGenerationTemplateDetailSettingsView,
        meta: { title: 'Einstellungen > Dokumentenvorlagendetails' }
      },
      {
        path: ROUTES.APP.SETTINGS.AI.BASE_SETTINGS,
        component: AiBaseSettingsView,
        meta: { title: 'Einstellungen > KI > Grundeinstellungen' }
      },
      {
        path: ROUTES.APP.SETTINGS.AI.PROMPT_TEMPLATES,
        component: PromptTemplateSettingsView,
        meta: { title: 'Einstellungen > KI > Promptvorlagen' }
      },
      {
        path: ROUTES.APP.SETTINGS.AI.PROMPT_TEMPLATE_DETAIL,
        component: PromptTemplateDetailSettingsView,
        meta: { title: 'Einstellungen > KI > Promptvorlage' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.ACTAPORT,
        component: ActaportSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Actaport' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.ADVOLUX,
        component: AdvoluxSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Advolux' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.ADVOWARE,
        component: AdvowareSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Advoware' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.ANNOTEXT,
        component: AnnotextSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Annotext' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.JURNODES,
        component: JurnodesSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Jurnodes' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.KLEOS,
        component: KleosSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Kleos' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.LAWFIRM,
        component: LawfirmSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > Lawfirm' }
      },
      {
        path: ROUTES.APP.SETTINGS.LAW_OFFICE_SOFTWARE.RA_MICRO,
        component: RaMicroSettingsView,
        meta: { title: 'Einstellungen > Kanzleisoftware > RA MICRO' }
      },
      // Default redirect to the first child path
      { path: ROUTES.APP.SETTINGS.ROOT, redirect: ROUTES.APP.SETTINGS.EMAILS.JUPUS_EMAIL }
    ]
  },
  {
    path: ROUTES.APP.CALLS.ROOT,
    name: 'Calls',
    children: [
      {
        path: ROUTES.APP.CALLS.ROOT,
        name: 'Calls List',
        component: CallListView,
        meta: {
          title: 'Anrufe'
        }
      },
      {
        path: ROUTES.APP.CALLS.CALL_DETAIL,
        name: 'Call Detail',
        component: CallDetailView,
        meta: {
          title: 'Anrufdetails'
        }
      }
    ]
  }
]

const clientPortalRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'Home',
    component: ClientPortalView,
    meta: {
      title: 'Ihre Anfrage'
    }
  },
  {
    path: 'questionnaire/:id',
    name: 'Questionnaires',
    component: QuestionnaireView,
    meta: {
      title: 'Fragebogen'
    }
  },
  {
    path: 'document/:id',
    name: 'PDF Documents',
    component: PdfView,
    meta: {
      title: 'Dokument'
    }
  },
  {
    path: 'external/document/:id',
    name: 'External PDF Documents',
    component: PdfView,
    meta: {
      title: 'Dokument'
    }
  },
  {
    path: 'external/pdf/:doc_creation_token/:case_uuid',
    name: 'PDF External Redirect',
    component: PdfExternalRedirectView,
    meta: {
      title: 'Dokument'
    }
  },
  {
    path: 'questionnaire/preview/:uuid',
    name: 'Questionnaires Preview',
    component: QuestionnairePreviewView,
    meta: {
      title: 'Fragebogen'
    }
  },
  {
    path: 'external/questionnaire/:org_questionnaire_creation_token/:questionnaire_questionnaire_creation_token',
    name: 'Questionnaires External Redirect',
    component: QuestionnaireExternalRedirectView,
    meta: {
      title: 'Fragebogen'
    }
  },
  {
    path: 'external/questionnaire/:id',
    name: 'Questionnaires External ',
    component: QuestionnaireExternalView,
    meta: {
      title: 'Fragebogen'
    }
  },
  {
    path: 'external/questionnaire/completed',
    name: 'Questionnaires External Completed',
    component: ExternalQuestionnaireCompletedView,
    meta: {
      title: 'Fragebogen'
    }
  },
  {
    path: 'call/feedback/:id',
    name: 'Voice Bot Feedback',
    component: VoiceBotFeedback,
    meta: {
      title: 'Anruf Feedback'
    }
  }
]

// Combine the routes
const routes: RouteRecordRaw[] = [
  {
    path: ROUTE_BASES.CLIENT_PORTAL_BASE,
    children: clientPortalRoutes
  },
  {
    path: ROUTE_BASES.ADMIN_BASE,
    children: adminRoutes
  },
  {
    path: ROUTE_BASES.APP_BASE,
    children: appRoutes
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

// Navigation guard to handle meta titles
router.beforeEach((to, from, next) => {
  // Get the matched route with the deepest meta title
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta?.title)

  // Set document title
  if (nearestWithTitle) {
    document.title = `${nearestWithTitle.meta.title} - Jupus`
  } else {
    document.title = 'Jupus'
  }

  next()
})

router.afterEach((to, from, failure) => {
  if (!failure) {
    setTimeout(() => {
      window.HSStaticMethods.autoInit()
    }, 100)
  }
})

export default router
